import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-api-tutorial',
  templateUrl: './api-tutorial.component.html',
  styleUrls: ['./api-tutorial.component.scss']
})
export class ApiTutorialRendererComponent implements OnInit {
    source = ''
    permittedPages: Array<string> = ['index','auth','codebook','engine']
  constructor(private router: Router,
    private route: ActivatedRoute
    ) {
        router.events.pipe(
            filter(event => event instanceof NavigationEnd)  
          ).subscribe((event: NavigationEnd) => {
            var page = this.route.snapshot.params['page'];
            if (this.permittedPages.includes(page)) {
                this.source = 'assets/content/api-tutorial-' + page + '.md'
            } else {
                window.location.href = "/";
            }
            
            
          });
    }

  ngOnInit(): void {

  }

  onMarkdownError(event) {
    console.error('MARKDOWN', event);
  }

}
